<template lang="pug">
div.staff-refund-modal.left
  OrderActionModal(:show="show" :max-width="'min(100vw - 2rem, 58rem)'" @close="closeModal")
    template(v-if="!success")
      form.modal-content(v-if="wizardStep === 1" ref="step1Form" @submit.prevent="goToStep2")
        .modal-title SOLICITAR REEMBOLSO
        .modal-subtitle Selecciona los productos que deseas reembolsar

        .items-list
          .item-row(v-for="(item, index) in items" :key="index" @click="toggleItem(item)" :class="{'item-row-selected': item.selected, 'item-row-disabled': item.disabled}")
            .item-check(@click.stop="toggleItem(item)")
              .checkbox(:class="{'checkbox-checked': item.selected, 'checkbox-disabled': item.disabled}")
                .check-icon(v-if="item.selected")
            .item-image
              picture(v-if="item.image")
                source(:srcset="item.imageWebp" type="image/webp")
                source(:srcset="item.image" type="image/jpeg")
                img(:src="item.image" :alt="item.productName" draggable="false")
            .item-info
              .item-name.uppercase {{ item.productName }}
              .item-size Talla: {{ item.size }} — Cant: {{ item.maxQuantity }}
              .item-price(v-if="!item.disabled")
                span.item-price-hint(v-if="item.selected && item.maxQuantity > 1 && !refundQtyChosen(item)") Elige cantidad
                span(v-else) {{ money(refundLineSubtotal(item)) }}
              .item-refunded-note(v-if="item.refundedQty > 0") {{ refundedNote(item) }}
              .item-quantity-row(v-if="item.selected && !item.disabled && item.maxQuantity > 1" @click.stop="")
                label.item-label ¿Cuántos deseas reembolsar?:
                select.item-select(
                  v-model="item.quantity"
                  required
                  @invalid="onRefundQtySelectInvalid"
                  @change="onRefundQtySelectClearValidity"
                )
                  option(disabled value="") —
                  option(v-for="n in item.maxQuantity" :key="n" :value="n") {{ n }}
              .item-reason-row(v-if="item.selected && !item.disabled" @click.stop="")
                select.item-reason(
                  v-model="item.reasonIndex"
                  required
                  @invalid="onRefundReasonSelectInvalid"
                  @change="onRefundReasonSelectClearValidity"
                )
                  option(disabled value="") Razón del reembolso
                  option(v-for="r in changeReasons" :key="r.index" :value="r.index") {{ r.reason }}

        .modal-error(v-if="error") {{ error }}

        .modal-actions
          button.button-submit(type="submit") Continuar

      .step2-layout(v-else-if="wizardStep === 2")
        .modal-content.refund-requirements-content
          .modal-title CONDICIONES PARA EL REEMBOLSO
          .modal-subtitle Confirma que cumples con lo siguiente:

          .requirements-list
            .requirement-row(
              role="button"
              tabindex="0"
              @click="toggleRequirement('unused')"
              @keydown.enter.prevent="toggleRequirement('unused')"
              :class="{'requirement-row--checked': refundReqUnused}"
            )
              .item-check(@click.stop="toggleRequirement('unused')")
                .checkbox(:class="{'checkbox-checked': refundReqUnused}")
                  .check-icon(v-if="refundReqUnused")
              span.requirement-text No se ha usado el producto

            .requirement-row(
              role="button"
              tabindex="0"
              @click="toggleRequirement('tags')"
              @keydown.enter.prevent="toggleRequirement('tags')"
              :class="{'requirement-row--checked': refundReqTags}"
            )
              .item-check(@click.stop="toggleRequirement('tags')")
                .checkbox(:class="{'checkbox-checked': refundReqTags}")
                  .check-icon(v-if="refundReqTags")
              span.requirement-text El producto aún cuenta con sus etiquetas

            .requirement-row(
              role="button"
              tabindex="0"
              @click="toggleRequirement('noPerfume')"
              @keydown.enter.prevent="toggleRequirement('noPerfume')"
              :class="{'requirement-row--checked': refundReqNoPerfume}"
            )
              .item-check(@click.stop="toggleRequirement('noPerfume')")
                .checkbox(:class="{'checkbox-checked': refundReqNoPerfume}")
                  .check-icon(v-if="refundReqNoPerfume")
              span.requirement-text No he aplicado perfume ni similares al producto

          .modal-error(v-if="error") {{ error }}

        .modal-actions.modal-actions--row.step2-actions
          button.wizard-back(type="button" @click.prevent.stop="backFromRequirements") Volver
          button.button-submit(type="button" @click.prevent="goToShippingAfterRequirements") Siguiente

      .step2-layout(v-else-if="wizardStep === 3")
        .modal-content.refund-shipping-step
          .modal-title ENVÍA LOS PRODUCTOS

          RefundShippingInstructions(:order-number="(order && order.order) || ''")

        .modal-actions.modal-actions--row.step2-actions
          button.wizard-back(type="button" @click.prevent.stop="backFromShipping") Volver
          button.button-submit(type="button" @click.prevent="goToMethodFromShipping") Siguiente

      .step2-layout(v-else-if="wizardStep === 4")
        form#staff-request-refund-step4-form.modal-content.refund-payout-step(@submit.prevent="handleStep4Submit")
          .modal-title
            | ¿CÓMO DESEAS RECIBIR LOS 
            strong.refund-payout-amount {{ money(selectedTotal) }}
            | ?

          .payout-options
            .payout-option(
              role="button"
              tabindex="0"
              @click="setPayoutMethod('bonus')"
              @keydown.enter.prevent="setPayoutMethod('bonus')"
              :class="{'payout-option--selected': payoutMethod === 'bonus'}"
            )
              .payout-option-title Bono de compra
              .payout-option-meta
                span.payout-option-meta-label ¿Cuándo lo recibo?
                span.payout-option-meta-value Inmediato

            template(v-if="isAddiOrder")
              .payout-option(
                role="button"
                tabindex="0"
                @click="setPayoutMethod('addi')"
                @keydown.enter.prevent="setPayoutMethod('addi')"
                :class="{'payout-option--selected': payoutMethod === 'addi'}"
              )
                .payout-option-title Devolución a Addi
                .payout-option-meta
                  span.payout-option-meta-label ¿Cuándo lo recibo?
                  span.payout-option-meta-value Una vez recibamos y verifiquemos los productos

            template(v-else)
              .payout-option(
                role="button"
                tabindex="0"
                @click="setPayoutMethod('llave')"
                @keydown.enter.prevent="setPayoutMethod('llave')"
                :class="{'payout-option--selected': payoutMethod === 'llave'}"
              )
                .payout-option-title Llave bancaria (Breve)
                .payout-option-meta
                  span.payout-option-meta-label ¿Cuándo lo recibo?
                  span.payout-option-meta-value 2 días hábiles después de recibir tu paquete

              .payout-option(
                role="button"
                tabindex="0"
                @click="setPayoutMethod('transfer')"
                @keydown.enter.prevent="setPayoutMethod('transfer')"
                :class="{'payout-option--selected': payoutMethod === 'transfer'}"
              )
                .payout-option-title Transferencia bancaria
                .payout-option-meta
                  span.payout-option-meta-label ¿Cuándo lo recibo?
                  span.payout-option-meta-value 5 días hábiles después de recibir tu paquete

          .addi-refund-notice(v-if="payoutMethod === 'addi'")
            p El préstamo de Addi disminuirá en 
              strong {{ money(selectedTotal) }}
              |  una vez recibamos y verifiquemos los productos.

          .payout-fields-wrap(v-if="!isAddiOrder")
            transition(name="slide-right")
              .transfer-fields(v-if="payoutMethod === 'transfer'")
                  h3.transfer-fields-title Datos para la transferencia

                  label.field-label(for="staff-refund-bank") Banco
                  select.field-input#staff-refund-bank(v-model="bank" required)
                    option(disabled value="") Selecciona el banco
                    option(v-for="b in refundBanks" :key="b.id" :value="b.description") {{ b.description }}

                  template(v-if="bank")
                    .id-fields
                      .id-type-wrap
                        label.field-label(for="staff-refund-doc-type") Tipo de documento
                        select.field-input#staff-refund-doc-type(v-model="docType" required)
                          option(disabled value="") Eligir
                          option(v-for="t in typeIdList" :key="t" :value="t") {{ t }}
                      .id-number-wrap
                        label.field-label(for="staff-refund-doc-number") Número de identificación
                        input.field-input#staff-refund-doc-number(v-model.trim="docNumber" type="text" inputmode="numeric" autocomplete="off" required placeholder="Número de documento")

                    label.field-label(for="staff-refund-owner") Nombre del titular de la cuenta
                    input.field-input#staff-refund-owner(v-model.trim="accountOwnerName" type="text" autocomplete="name" required placeholder="Nombre completo")

                    label.field-label(for="staff-refund-account") Número de cuenta
                    input.field-input#staff-refund-account(v-model.trim="accountNumber" type="text" inputmode="numeric" autocomplete="off" required placeholder="Número de cuenta")

                    label.field-label(for="staff-refund-type") Tipo de cuenta
                    select.field-input#staff-refund-type(v-model="accountType" required)
                      option(disabled :value="''") Selecciona el tipo
                      option(value="0") Ahorros
                      option(value="1") Corriente

              transition(name="slide-right")
                .transfer-fields(v-if="payoutMethod === 'llave'")
                  h3.transfer-fields-title Datos para la llave bancaria (Breve)
                  label.field-label(for="staff-refund-llave") Llave
                  input.field-input#staff-refund-llave(v-model.trim="llave" type="text" autocomplete="off" required placeholder="Tu llave")

                  label.field-label(for="staff-refund-llave-owner") Nombre del titular de la llave
                  input.field-input#staff-refund-llave-owner(v-model.trim="llaveOwner" type="text" autocomplete="name" required placeholder="Nombre completo")

          .modal-error(v-if="error") {{ error }}

        .modal-actions.modal-actions--row.step2-actions
          button.wizard-back(type="button" @click.prevent.stop="backFromPayout") Volver
          button.button-submit(type="submit" form="staff-request-refund-step4-form" :disabled="!canSubmitFinal || isLoading")
            span(v-if="!isLoading && payoutMethod === 'bonus' && !selectedTotal") Solicitar bono
            span(v-else-if="!isLoading && payoutMethod === 'bonus'") Solicitar bono {{ money(selectedTotal) }}
            span(v-else-if="!isLoading && payoutMethod === 'addi'") Solicitar reembolso
            span(v-else-if="!isLoading && payoutMethod === 'transfer'") Solicitar reembolso
            span(v-else-if="!isLoading && payoutMethod === 'llave'") Solicitar reembolso
            span(v-else-if="!isLoading") Siguiente
            span(v-else) Enviando...

    BonusShippingSuccessPanel(
      v-else-if="success"
      :created-bonus="createdBonusSummary"
      :refund-id="createdRefundId"
      :shipping-order="(order && order.order) || ''"
      @close="doneAfterSuccess"
    )
</template>

<script>
import OrderActionModal from './OrderActionModal.vue'
import BonusShippingSuccessPanel from './BonusShippingSuccessPanel.vue'
import RefundShippingInstructions from './RefundShippingInstructions.vue'
import mFilters from '@/mixins/filters'
import gql from '@my/graphql'
import gqlRefund from '@/graphql/refund'
import gqlChangeReason from '@/graphql/changeReason'
import modals from '@my/store/modals'

const REFUND_METHOD_TRANSFER = 'transfer'
const REFUND_METHOD_BONUS = 'bonus'
const REFUND_METHOD_LLAVE = 'llave'
const REFUND_METHOD_ADDI = 'addi'

const REFUND_REQUIREMENTS_ERROR = 'El producto no aplica para reembolsos si no se cumplen los requerimientos.'

export default {
  name: 'StaffRequestRefundModal',

  components: { OrderActionModal, BonusShippingSuccessPanel, RefundShippingInstructions },

  mixins: [mFilters],

  props: {
    order: {
      type: Object,
      required: true
    },
    imagePathBase: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      show: false,
      notifyOnRefund: true,
      wizardStep: 1,
      payoutMethod: null,
      accountOwnerName: '',
      accountNumber: '',
      accountType: '',
      bank: '',
      docType: '',
      docNumber: '',
      llave: '',
      llaveOwner: '',
      typeIdList: ['CC', 'CE', 'CEL', 'DE', 'IDC', 'NIT', 'PP', 'RC', 'TI'],
      items: [],
      changeReasons: [],
      refundBanks: [],
      isLoading: false,
      error: '',
      success: false,
      successKind: null,
      refundReqUnused: false,
      refundReqTags: false,
      refundReqNoPerfume: false,
      createdBonusSummary: null,
      createdRefundId: null
    }
  },

  computed: {
    hasSelection () {
      const selected = this.items.filter(item => item.selected && !item.disabled)
      if (!selected.length) return false
      return selected.every(item => this.refundQtyChosen(item))
    },
    selectedProducts () {
      return this.items
        .filter(item => item.selected && this.refundQtyChosen(item))
        .map(item => ({
          product: item.productName,
          size: item.size,
          quantity: Number(item.quantity),
          reason: item.reasonIndex === '' || item.reasonIndex === null || item.reasonIndex === undefined
            ? null
            : item.reasonIndex
        }))
    },
    selectedTotal () {
      return this.items
        .filter(item => item.selected && this.refundQtyChosen(item))
        .reduce((sum, item) => sum + item.unitPrice * Number(item.quantity), 0)
    },
    transferFieldsValid () {
      return (
        this.accountOwnerName.trim() !== '' &&
        this.accountNumber.trim() !== '' &&
        this.accountType !== '' &&
        this.bank !== '' &&
        this.docType !== '' &&
        this.docNumber.trim() !== ''
      )
    },
    llaveFieldsValid () {
      return this.llave.trim() !== '' && this.llaveOwner.trim() !== ''
    },
    isAddiOrder () {
      return !!(this.order && this.order.methodPay === 'addi')
    },
    canSubmitFinal () {
      if (!this.payoutMethod) return false
      if (this.payoutMethod === 'bonus') return true
      if (this.payoutMethod === 'addi') return true
      if (this.payoutMethod === 'transfer') return this.transferFieldsValid
      if (this.payoutMethod === 'llave') return this.llaveFieldsValid
      return false
    },
    refundRequirementsMet () {
      return this.refundReqUnused && this.refundReqTags && this.refundReqNoPerfume
    }
  },

  methods: {
    open (opts = {}) {
      if (!this.order || !this.order.order) return
      if (this.order.status !== 'sent') {
        modals.showMessage({
          message: `Solo se puede generar reembolso cuando la orden está en estado Enviado (actual: ${this.order.status}).`,
          type: 'error'
        })
        return
      }
      this.notifyOnRefund = opts.sendNotifications !== false
      this.items = this.buildItems()
      this.error = ''
      this.success = false
      this.successKind = null
      this.createdBonusSummary = null
      this.createdRefundId = null
      this.wizardStep = 1
      this.resetRefundRequirements()
      this.payoutMethod = null
      this.accountOwnerName = ''
      this.accountNumber = ''
      this.accountType = ''
      this.bank = ''
      this.docType = ''
      this.docNumber = ''
      this.llave = ''
      this.llaveOwner = ''
      this.show = true
      this.prefetchRefundLookups()
    },

    async prefetchRefundLookups () {
      try {
        const [reasonsRes, banksRes] = await Promise.all([
          gql.query(gqlChangeReason.GET_ALL, {}, false),
          gql.query(gqlRefund.GET_REFUND_BANKS, {}, false)
        ])
        this.changeReasons = (reasonsRes && reasonsRes.data && reasonsRes.data.getChangeReasons) || []
        this.refundBanks = (banksRes && banksRes.data && banksRes.data.getRefundBanks) || []
      } catch (e) {
        this.changeReasons = []
        this.refundBanks = []
      }
    },

    closeModal () {
      if (this.success) this.$emit('refresh')
      this.show = false
      this.success = false
      this.successKind = null
      this.createdBonusSummary = null
      this.createdRefundId = null
      this.wizardStep = 1
      this.resetRefundRequirements()
      this.payoutMethod = null
      this.accountOwnerName = ''
      this.accountNumber = ''
      this.accountType = ''
      this.bank = ''
      this.docType = ''
      this.docNumber = ''
      this.llave = ''
      this.llaveOwner = ''
    },

    doneAfterSuccess () {
      this.closeModal()
    },

    toggleItem (item) {
      if (item.disabled) return
      item.selected = !item.selected
      if (item.selected) {
        item.quantity = item.maxQuantity > 1 ? '' : 1
      } else {
        item.quantity = item.maxQuantity > 1 ? '' : 1
      }
    },

    refundQtyChosen (item) {
      if (!item.selected || item.disabled) return false
      if (item.maxQuantity <= 1) {
        const n = Number(item.quantity)
        return !Number.isNaN(n) && n >= 1
      }
      const q = item.quantity
      if (q === '' || q === null || q === undefined) return false
      const n = Number(q)
      return !Number.isNaN(n) && n >= 1 && n <= item.maxQuantity
    },

    refundLineSubtotal (item) {
      if (!item.selected) return item.unitPrice
      if (item.maxQuantity > 1 && !this.refundQtyChosen(item)) return 0
      return item.unitPrice * Number(item.quantity)
    },

    onRefundQtySelectInvalid (e) {
      e.target.setCustomValidity('Selecciona la cantidad')
    },

    onRefundQtySelectClearValidity (e) {
      e.target.setCustomValidity('')
    },

    onRefundReasonSelectInvalid (e) {
      e.target.setCustomValidity('Selecciona la razón')
    },

    onRefundReasonSelectClearValidity (e) {
      e.target.setCustomValidity('')
    },

    refundedNote (item) {
      if (item.disabled) return 'Ya solicitaste reembolso de todas las unidades de esta talla'
      return `Ya solicitaste reembolso de ${item.refundedQty} de ${item.originalQty} unidades de esta talla`
    },

    setPayoutMethod (method) {
      this.payoutMethod = method
      this.error = ''
    },

    toggleRequirement (key) {
      if (key === 'unused') this.refundReqUnused = !this.refundReqUnused
      else if (key === 'tags') this.refundReqTags = !this.refundReqTags
      else if (key === 'noPerfume') this.refundReqNoPerfume = !this.refundReqNoPerfume
      this.error = ''
    },

    goToShippingAfterRequirements () {
      if (!this.refundRequirementsMet) {
        this.error = REFUND_REQUIREMENTS_ERROR
        return
      }
      this.error = ''
      this.wizardStep = 3
    },

    goToMethodFromShipping () {
      this.error = ''
      this.payoutMethod = null
      this.accountOwnerName = ''
      this.accountNumber = ''
      this.accountType = ''
      this.bank = ''
      this.docType = ''
      this.docNumber = ''
      this.llave = ''
      this.llaveOwner = ''
      this.wizardStep = 4
    },

    backFromShipping () {
      this.wizardStep = 2
      this.error = ''
    },

    backFromRequirements () {
      this.wizardStep = 1
      this.error = ''
      this.refundReqUnused = false
      this.refundReqTags = false
      this.refundReqNoPerfume = false
    },

    backFromPayout () {
      this.wizardStep = 3
      this.error = ''
    },

    handleStep4Submit () {
      if (!this.canSubmitFinal || !this.hasSelection) return
      this.error = ''
      this.submitFinal()
    },

    resetRefundRequirements () {
      this.refundReqUnused = false
      this.refundReqTags = false
      this.refundReqNoPerfume = false
    },

    goToStep2 () {
      const form = this.$refs.step1Form
      if (!form) return
      const hasAnySelected = this.items.some(item => item.selected && !item.disabled)
      if (!hasAnySelected) {
        this.error = 'Selecciona al menos un producto para continuar.'
        return
      }
      this.error = ''
      if (!form.checkValidity()) {
        form.reportValidity()
        return
      }
      this.wizardStep = 2
    },

    refundObservationSummary () {
      return this.selectedProducts
        .map(p => `${p.product} (${p.size}) x${p.quantity}`)
        .join('; ')
    },

    buildItems () {
      const cart = this.order && this.order.cart
      if (!cart || !cart.length) return []

      const codePercent =
        this.order && this.order.codeName && this.order.codePercent ? this.order.codePercent : 0

      const items = []
      const baseImage = this.imagePathBase || ''

      cart.forEach(product => {
        const basePrice = product.appliedPrice || 0
        const unitPrice = codePercent ? Math.round(basePrice * (1 - codePercent / 100)) : basePrice

        product.sizes.forEach((size, i) => {
          const qty = product.quantityCart[i]
          if (!qty || qty <= 0) return

          const refundedQty =
            product.refundedQuantity && product.refundedQuantity[i]
              ? product.refundedQuantity[i]
              : 0
          const availableQty = Math.max(qty - refundedQty, 0)
          const disabled = availableQty <= 0

          const basePath = `${baseImage}/${product.brand}/${product.folder}/${product.subfolder}`
          const img =
            product.images && product.images.length ? product.images[0] : null

          items.push({
            productName: product.product,
            size,
            maxQuantity: availableQty,
            originalQty: qty,
            refundedQty,
            quantity: disabled ? 0 : (availableQty > 1 ? '' : 1),
            unitPrice,
            reasonIndex: '',
            selected: false,
            disabled,
            image: img ? `${basePath}/${img}` : '',
            imageWebp: img ? `${basePath}/${img.replace('.jpg', '.webp')}` : ''
          })
        })
      })
      return items
    },

    async submitFinal () {
      if (!this.canSubmitFinal || !this.hasSelection) return

      if (this.payoutMethod === 'transfer' && !this.transferFieldsValid) {
        this.error = 'Completa todos los datos bancarios obligatorios.'
        return
      }

      if (this.payoutMethod === 'llave' && !this.llaveFieldsValid) {
        this.error = 'Completa la llave y el nombre del titular.'
        return
      }

      this.isLoading = true
      this.error = ''

      try {
        let refundMethod = REFUND_METHOD_TRANSFER
        if (this.payoutMethod === 'bonus') {
          refundMethod = REFUND_METHOD_BONUS
        } else if (this.payoutMethod === 'addi') {
          refundMethod = REFUND_METHOD_ADDI
        } else if (this.payoutMethod === 'llave') {
          refundMethod = REFUND_METHOD_LLAVE
        }

        const input = {
          order: this.order.order,
          value: Math.round(this.selectedTotal),
          method: refundMethod,
          observation: this.refundObservationSummary(),
          products: this.selectedProducts
        }

        if (this.payoutMethod === 'transfer') {
          input.account = this.accountNumber.trim()
          input.accountType = this.accountType
          input.accountOwnerName = this.accountOwnerName.trim()
          input.accountOwnerDniType = this.docType
          input.accountOwnerDni = this.docNumber.trim()
          input.bank = this.bank
        }

        if (this.payoutMethod === 'llave') {
          input.llave = this.llave.trim()
          input.llaveOwner = this.llaveOwner.trim()
        }

        const res = await gql.mutate(gqlRefund.STAFF_REQUEST, {
          input,
          sendNotifications: !!this.notifyOnRefund
        }, false)

        if (!res || res.error) {
          this.error = (res && res.error) || 'Error al enviar la solicitud'
        } else {
          const result = res.data && res.data.staffRequestRefund
          if (result && result.success) {
            this.successKind = this.payoutMethod
            this.createdBonusSummary = result.bonus || null
            this.createdRefundId = result.refundId || null
            this.success = true
          } else {
            this.error = 'No se pudo completar la solicitud'
          }
        }
      } catch (e) {
        this.error = 'Error al enviar la solicitud'
      }

      this.isLoading = false
    }
  }
}
</script>

<style lang="stylus" scoped>
.staff-refund-modal
  display contents

.modal-content
  padding 0 1.75rem 1.75rem
  overflow-y auto
  flex 1

form.modal-content
  margin 0
  display block
  width 100%
  box-sizing border-box
  border none

.step2-layout
  display flex
  flex-direction column
  flex 1
  min-height 0
  width 100%

.step2-layout > .modal-content
  flex 1
  min-height 0
  padding-bottom .5rem

.refund-requirements-content
  padding-top .25rem

.requirements-list
  display flex
  flex-direction column
  gap .75rem

.requirement-row
  display flex
  gap .8rem
  align-items flex-start
  padding 1rem 1.15rem
  border 2px solid rgba(0, 0, 0, 0.12)
  border-radius 2px
  cursor pointer
  text-align left
  font-family inherit
  background var(--background-principal, #fff)
  transition border-color .15s, background .15s

  &:hover
    border-color rgba(0, 0, 0, 0.28)

.requirement-row--checked
  border-color rgba(0, 0, 0, 0.45)
  background rgba(0, 0, 0, 0.03)

.requirement-text
  flex 1
  font-size 1.1rem
  line-height 1.45
  padding-top .15rem

.step2-actions
  flex-shrink 0
  padding 0 1.75rem 1.75rem
  margin-top 1.5rem

.modal-title
  font-weight 600
  font-size 1.35rem
  margin-bottom .4rem

.refund-shipping-step > .modal-title
  margin-bottom 2rem

.refund-payout-step > .modal-title
  margin-bottom 2rem

.refund-payout-amount
  color var(--color-green, #51a540)
  font-weight 600

.modal-subtitle
  font-size 1.1rem
  margin-bottom 1.65rem
  opacity .7

.wizard-back
  padding .6rem 0
  border none
  background none
  font-size 1.05rem
  font-family inherit
  color #000
  text-decoration underline
  cursor pointer
  opacity .75
  flex-shrink 0

  &:hover
    opacity 1

.payout-options
  display flex
  flex-direction column
  gap .75rem
  margin-bottom 1.25rem

.payout-option
  padding 1.15rem 1.2rem
  border 2px solid rgba(0, 0, 0, 0.12)
  border-radius 2px
  cursor pointer
  text-align left
  transition border-color .15s, background .15s
  font-family inherit
  background var(--background-principal, #fff)

  &:hover
    border-color rgba(0, 0, 0, 0.28)

.payout-option--selected
  border-color rgba(0, 0, 0, 0.55)
  background rgba(0, 0, 0, 0.03)

.payout-option-title
  font-weight 700
  font-size 1.15rem
  margin 0 0 .35rem
  line-height 1.4

.payout-option-meta
  display grid
  grid-template-columns minmax(10rem, 13.5rem) minmax(0, 1fr)
  column-gap .75rem
  align-items baseline
  margin-top .75rem
  padding-top .65rem
  border-top 1px solid rgba(0, 0, 0, 0.08)

.payout-option-meta-label
  font-size .95rem
  font-weight 600
  color rgba(0, 0, 0, 0.5)

.payout-option-meta-value
  font-size 1.02rem
  line-height 1.4

.addi-refund-notice
  padding 1.15rem 1.2rem
  border 2px solid rgba(0, 0, 0, 0.12)
  border-radius 2px
  background rgba(0, 0, 0, 0.03)
  margin-bottom 1.25rem

  p
    margin 0
    font-size 1.08rem
    line-height 1.5

.transfer-fields
  display flex
  flex-direction column
  gap .65rem
  margin-bottom 1.25rem
  margin-top .5rem

.payout-fields-wrap
  position relative
  overflow hidden
  width 100%

.transfer-fields-title
  margin 0 0 .35rem
  font-size 1.1rem
  font-weight 700
  line-height 1.3

.field-label
  font-size 1.02rem
  font-weight 600

.field-input
  width 100%
  padding .55rem .65rem
  border 1px solid rgba(0, 0, 0, 0.2)
  background var(--background-principal, #fff)
  font-size 1.08rem
  font-family inherit
  box-sizing border-box

.items-list
  display flex
  flex-direction column
  gap 1rem

.item-row
  display flex
  gap .8rem
  align-items flex-start
  padding .95rem 1rem
  border 1px solid rgba(0, 0, 0, 0.08)
  cursor pointer
  transition border-color .15s

  &:hover
    border-color rgba(0, 0, 0, 0.25)

.item-row-selected
  border-color rgba(0, 0, 0, 0.4)

.item-row-disabled
  cursor not-allowed
  opacity .55
  background rgba(0, 0, 0, 0.025)

  &:hover
    border-color rgba(0, 0, 0, 0.08)

  .item-check, .checkbox
    cursor not-allowed

.checkbox-disabled
  border-color rgba(0, 0, 0, 0.2)
  background rgba(0, 0, 0, 0.05)

.item-refunded-note
  font-size 1rem
  font-style italic
  opacity .75
  margin-top .1rem

.item-check
  padding-top .2rem
  flex-shrink 0

.checkbox
  width 1.45rem
  height 1.45rem
  border 2px solid rgba(0, 0, 0, 0.4)
  cursor pointer
  display flex
  align-items center
  justify-content center
  transition all .15s

.checkbox-checked
  background-color #000
  border-color #000

.check-icon
  width .52rem
  height .82rem
  border-right 2px solid #fff
  border-bottom 2px solid #fff
  transform rotate(45deg)
  margin-top -.1rem

.item-image
  flex-shrink 0
  width 7rem

  img
    width 100%
    height auto
    display block

.item-info
  flex 1
  display flex
  flex-direction column
  gap .4rem
  font-size 1.08rem

.item-name
  font-weight 600

.item-size
  opacity .7

.item-price
  font-weight 600

.item-price-hint
  font-weight 400
  opacity .55
  font-size 1rem

.item-quantity-row, .item-reason-row
  display flex
  align-items center
  gap .5rem
  margin-top .2rem

.item-label
  font-size 1.05rem

.item-select
  padding .3rem .5rem
  border 1px solid rgba(0, 0, 0, 0.2)
  background var(--background-principal, #fff)
  font-size 1.05rem

.item-reason
  width 100%
  padding .5rem .6rem
  border 1px solid rgba(0, 0, 0, 0.2)
  background var(--background-principal, #fff)
  font-size 1.05rem
  font-family inherit

.id-fields
  display flex
  gap .65rem
  align-items flex-end

.id-type-wrap
  flex-basis 8rem
  flex-shrink 0
  display flex
  flex-direction column
  gap .65rem

.id-number-wrap
  flex 1
  display flex
  flex-direction column
  gap .65rem

.modal-error
  color #c00
  font-size 1.05rem
  margin-top 1rem

.modal-actions
  margin-top 1.5rem
  display flex
  justify-content flex-end

.modal-actions--row
  justify-content space-between
  align-items center
  gap 1rem
  flex-wrap wrap

.button-submit
  background-color #000
  color #fff
  border none
  padding .72rem 1.65rem
  font-size 1.12rem
  font-family inherit
  cursor pointer
  text-transform uppercase
  font-weight 600

  &:disabled
    opacity .4
    cursor not-allowed
</style>



// WEBPACK FOOTER //
// src/components/pages/order/refund/StaffRequestRefundModal.vue